import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import HomePage from '../pages/home/page';
import FeaturesPage from '../pages/features/page';
import BlogIndexPage from '../pages/blog/page';
import ArticleAITravelIndustry from '../pages/blog/ai-travel-agency-2025/page';
import ArticleWhatsAppBookings from '../pages/blog/whatsapp-bookings/page';
import ArticleBookingConversions from '../pages/blog/booking-conversions-ai/page';
import LoginPage from '../pages/auth/login/page';
import RegisterPage from '../pages/auth/register/page';
import SuperAdminLoginPage from '../pages/super-admin/login/page';
import AppLayout from '../components/feature/Layout/AppLayout';
import ProtectedRoute from '../components/feature/ProtectedRoute';
import DashboardPage from '../pages/dashboard/page';
import ComingSoonPage from '../components/feature/ComingSoonPage';
import LeadsPage from '../pages/crm/leads/page';
import CustomersPage from '../pages/crm/customers/page';
import TasksPage from '../pages/crm/tasks/page';
import BookingsPage from '../pages/bookings/page';
import NewBookingPage from '../pages/bookings/new/page';
import ItineraryListPage from '../pages/itinerary/page';
import ItineraryBuilderPage from '../pages/itinerary/builder/page';
import InvoicesPage from '../pages/invoices/page';
import NewInvoicePage from '../pages/invoices/new/page';
import VouchersPage from '../pages/vouchers/page';
import ProductsPage from '../pages/products/page';
import SettingsPage from '../pages/settings/page';
import EmailPage from '../pages/email/page';
import WhatsAppPage from '../pages/whatsapp/page';
import LeadCapturePage from '../pages/lead-capture/page';
import QuotesPage from '../pages/quotes/page';
import SuppliersPage from '../pages/suppliers/page';
import SuperAdminPage from '../pages/super-admin/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/features',
    element: <FeaturesPage />,
  },
  {
    path: '/blog',
    element: <BlogIndexPage />,
  },
  {
    path: '/blog/ai-transforming-travel-agency-industry-2025',
    element: <ArticleAITravelIndustry />,
  },
  {
    path: '/blog/automating-whatsapp-bookings-travel-agents',
    element: <ArticleWhatsAppBookings />,
  },
  {
    path: '/blog/increasing-booking-conversions-ai-follow-up',
    element: <ArticleBookingConversions />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  {
    path: '/',
    element: <ProtectedRoute><AppLayout /></ProtectedRoute>,
    children: [
      {
        path: '/dashboard',
        element: <DashboardPage />,
      },
      {
        path: '/crm/leads',
        element: <LeadsPage />,
      },
      {
        path: '/crm/customers',
        element: <CustomersPage />,
      },
      {
        path: '/crm/tasks',
        element: <TasksPage />,
      },
      {
        path: '/bookings',
        element: <BookingsPage />,
      },
      {
        path: '/bookings/new',
        element: <NewBookingPage />,
      },
      {
        path: '/products',
        element: <ProductsPage />,
      },
      {
        path: '/itinerary',
        element: <ItineraryListPage />,
      },
      {
        path: '/itinerary/new',
        element: <ItineraryBuilderPage />,
      },
      {
        path: '/itinerary/builder',
        element: <ItineraryBuilderPage />,
      },
      {
        path: '/quotes',
        element: <QuotesPage />,
      },
      {
        path: '/invoices',
        element: <InvoicesPage />,
      },
      {
        path: '/invoices/new',
        element: <NewInvoicePage />,
      },
      {
        path: '/vouchers',
        element: <VouchersPage />,
      },
      {
        path: '/suppliers',
        element: <SuppliersPage />,
      },
      {
        path: '/email',
        element: <EmailPage />,
      },
      {
        path: '/lead-capture',
        element: <LeadCapturePage />,
      },
      {
        path: '/whatsapp',
        element: <WhatsAppPage />,
      },
      {
        path: '/settings',
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: '/sa-login',
    element: <SuperAdminLoginPage />,
  },
  {
    path: '/super-admin',
    element: <ProtectedRoute><SuperAdminPage /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
